//@ts-ignore
import styled from "styled-components";

import { PartialCircleLoading } from "components/report/atoms/PartialCircleLoading";

import { BusinessDashboard } from "components/businessDashboard/Dashboard";
import { DashboardPageLayout } from "components/businessDashboard/DashboardPageLayout";

export default function BusinessDashboardPage() {
  const isLoading = false;

  const handleRefreshPage = async () => {};

  return (
    <DashboardPageLayout handleRefresh={handleRefreshPage}>
      {isLoading ? (
        <CustomPartialCircleLoading width={180} />
      ) : (
        <BusinessDashboard />
      )}
    </DashboardPageLayout>
  );
}

const CustomPartialCircleLoading = styled(PartialCircleLoading)`
  height: auto;
  position: relative;
  top: 84px;
`;
